const isBrowserCode = `import { isBrowser } from 'cristatus';

const isBrowser = isBrowser(); //true (if in browser)
`;

export default isBrowserCode;
